interface ReactionFloatersProps {
  /** The emoji currently on this tile, or null. */
  emoji: string | null
}

/**
 * One emoji floating up out of a participant's tile.
 *
 * This is the burst that used to live at stage level, pinned to the right edge
 * of the whole meeting area — so every reaction appeared to come from the same
 * place regardless of who sent it. Rendered inside the tile, the origin IS the
 * attribution: the emoji rises from the person who reacted.
 *
 * ONE emoji, not a shower of them. It used to draw twelve copies of the same
 * character on staggered delays over about three seconds, which read as the
 * reaction having been sent twelve times — a single tap looked like a stuck
 * button, and there was no way to tell it apart from someone genuinely tapping
 * repeatedly. The count was decoration; the information is that this person
 * reacted, once.
 */
export function ReactionFloaters({ emoji }: ReactionFloatersProps) {
  if (!emoji) return null

  return (
    <div className="pointer-events-none absolute inset-0 z-20 overflow-hidden">
      <div
        // Keyed on the emoji so reacting again restarts the animation rather
        // than letting the second one ride out the first one's remaining time.
        key={emoji}
        className="absolute bottom-6 right-[14%] text-[22px] opacity-0"
        style={{
          animationName: "floatingWaves",
          animationDuration: "2600ms",
          animationTimingFunction: "ease-in-out",
          animationFillMode: "forwards",
        }}
      >
        {emoji}
      </div>
    </div>
  )
}
